import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useTrip } from "@/context/TripContext";

const NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER;

function buildMessage({ safari, date, slot, type }) {
  if (!safari) return "Hi JawaiTrails! I'd like help planning a leopard safari in Jawai.";
  const parts = [`Hi JawaiTrails! I'm interested in the ${safari}`];
  if (type) parts.push(`(${type === "private" ? "private jeep" : "shared jeep"})`);
  if (date) parts.push(`on ${date}`);
  if (slot) parts.push(`at ${slot}`);
  return parts.join(" ") + ". Can you help me book?";
}

export default function WhatsAppButton() {
  const { trip } = useTrip();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const href = `https://wa.me/${NUMBER}?text=${encodeURIComponent(buildMessage(trip))}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Chat with us on WhatsApp"
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#1E3A2B] pl-4 pr-5 py-3 text-[#FAF7F2] shadow-xl shadow-black/25 ring-2 ring-[#D4A359]/60 hover:bg-[#14281D] hover:-translate-y-0.5"
    >
      <span className="relative flex h-8 w-8 items-center justify-center rounded-full bg-[#25D366]">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-40" />
        <MessageCircle size={18} className="relative text-white" />
      </span>
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="text-sm font-semibold">Booking help</span>
        <span className="text-[11px] text-[#D4A359]" data-testid="whatsapp-float-context">
          {trip.safari ? `About: ${trip.safari}${trip.date ? " · " + trip.date : ""}` : "Chat on WhatsApp"}
        </span>
      </span>
    </a>
  );
}
